import { render, staticRenderFns } from "./CustomerLoginList.vue?vue&type=template&id=4b504c8a&"
import script from "./CustomerLoginList.vue?vue&type=script&lang=js&"
export * from "./CustomerLoginList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports